/* eslint-disable react/jsx-key */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import { useState } from 'react'
import { strCol, numCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitHeader,
} from 'core/HeaderColTypeProps'
import { getApiTargetInfo, UtilityUnitSelection } from 'core'
import { connect } from 'react-redux'
import * as R from 'ramda'

import {
  getNERCCapacityInfo,
  postNERCCapacityInfo,
  deleteNERCCapacityInfo,
} from 'api/pgads.js'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
} from 'core/selectors'
import CommonScreen from './CommonScreen'
import { Select, Button, InputNumber } from 'antd'
const { Option } = Select

const retrieveTask = apiTargetInfo => () => getNERCCapacityInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postNERCCapacityInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteNERCCapacityInfo(apiTargetInfo)(data)

const monthOption = R.range(1, 13).map(i => ({
  key: `${i}`,
  value: `${i}`,
  text: `${i}`,
}))

const headers = [
  utilityHeader,
  unitHeader,
  strCol({
    ident: 'month',
    display: 'Month',
    isKey: true,
  }),
  numCol({
    ident: 'netDepCap',
    display: 'Net Dependable Capacity',
    isRequired: true,
  }),
  numCol({
    ident: 'grossDepCap',
    display: 'Gross Dependable Capacity',
  }),
  modifierCol,
  modifiedDateCol,
]

const title = 'NERC Capacity'

const NERCCapacity = props => {
  // componentDidMount() {
  //   const { apiTargetInfo } = this.props
  //   getUtilityUnitMap(apiTargetInfo).fork(this.setErr, utilityUnitMap =>
  //     this.setState({ utilityUnitMap })
  //   )
  // }

  const [insertEvent, setInsertEvent] = useState(false)

  const { utilityNameMap, unitNameMap, utilityUnitMap } = props

  const generateDataGetter = ({ rowData, header }) => {
    if (header.ident === 'unit') header.choices = []
    if (rowData.utility !== '' && rowData.utility !== undefined) {
      if (header.ident === 'unit') {
        const unitList = utilityUnitMap && utilityUnitMap[rowData.utility]
        header.choices = unitList
          ? unitList.map(value => ({
              text: unitNameMap[value] || value,
              value,
            }))
          : []

        return rowData.unit
      }
    }
  }

  const headerWithFormatter = headers.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : header.ident === 'unit'
      ? {
          ...header,
          choices: [],
          dataGetter: generateDataGetter,
          dataFormatter: ({ value }) => unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unit] || rowData.unit,
        }
      : header.ident === 'month'
      ? {
          ...header,
          choices: monthOption,
        }
      : header
  )

  // const mapVal = R.compose(
  //   R.map(([key, text]) => ({ key, text, value: key })),
  //   R.sortBy(([, text]) => text.toLowerCase()),
  //   R.toPairs
  // )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <table
      style={{
        width: '100%',
        borderSpacing: '10px',
        borderCollapse: 'inherit',
      }}
    >
      <tbody>
        <tr>
          <td style={{ width: '100px' }}>Utility / Unit :</td>
          <td style={{ minWidth: '600px' }}>
            <UtilityUnitSelection
              className="utilityUnit"
              utility={insertData.utility}
              unit={insertData.unit}
              onUnitChange={value => {
                // setUtilityUnit(value)
                setInsertData({
                  ...insertData,
                  utility: value[0],
                  unit: value[1],
                })
              }}
            />
            {/* <Select
              style={{ display: 'grid' }}
              showSearch
              placeholder="Select a Utility"
              // optionFilterProp="children"
              value={insertData.utility}
              onChange={value => {
                setInsertData({
                  ...insertData,
                  unit: undefined,
                  utility: value,
                })
              }}
              // onFocus={onFocus}
              // onBlur={onBlur}
              // onSearch={onSearch}
              // filterOption={(input, option) =>
              //   option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              // }
            >
              {mapVal(utilityNameMap).map(ut => (
                <Option value={ut.key}>{ut.text}</Option>
              ))}
            </Select> */}
          </td>

          <td>Gross Dependable Capacity: </td>
          <td>
            <InputNumber
              placeholder="Gross Capacity"
              className="grossDependableCapacity"
              defaultValue={0}
              onChange={value =>
                setInsertData({ ...insertData, grossDepCap: value })
              }
            />
          </td>
        </tr>
        <tr>
          <td style={{}}>Month :</td>
          <td>
            <Select
              id="month"
              className="month"
              style={{ width: '60px' }}
              onChange={value => setInsertData({ ...insertData, month: value })}
            >
              {monthOption.map(m => (
                <Option value={m.key}>{m.value}</Option>
              ))}
            </Select>
          </td>

          {/* </tr>
        <tr> */}

          <td style={{ width: '200px' }}>Net Dependable Capacity:</td>
          <td>
            <InputNumber
              placeholder="Net Capacity"
              className="netDependableCapacity"
              defaultValue={0}
              onChange={value =>
                setInsertData({ ...insertData, netDepCap: value })
              }
            />
          </td>
          <td>
            <Button type="primary" onClick={() => onAdd(true)}>
              Add
            </Button>
          </td>
          <td>
            <Button type="primary" onClick={() => onAdd(false)}>
              Add & Hide
            </Button>
          </td>
          <td>
            <Button type="danger" onClick={onCancel}>
              Cancel
            </Button>
          </td>
        </tr>
      </tbody>
    </table>
  )

  return [
    <CommonScreen
      title={title}
      header={headerWithFormatter}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      withCriteria={(state, props, selectedUnits) => selectedUnits}
      withUnitSelection={false}
      deleteTask={deleteTask}
      autoRetrieve
      altBy={d => d.unit}
      sortOptions={[utilityHeader, unitHeader]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={60}
      defaultInsertData={{ netDepCap: 0, grossDepCap: 0 }}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
})

export default connect(mapStateToProps)(NERCCapacity)
